const DEFAULT_PAGE_SIZE = 10;

/**
 * Eine Paginierung Konfiguration
 * Das Objekt ist immutable (read-only), das kann entweder neue erstellen oder klonieren werden.
 */
export class PaginationPage {
    readonly number: number;
    readonly size: number;
    readonly totalElements: number;

    get last(): boolean {
        return this.number + 1 === this.totalPages;
    }

    get first(): boolean {
        return this.number === 0;
    }

    get totalPages(): number {
        if (!this.size) {
            return 0;
        }

        return Math.ceil(this.totalElements / this.size);
    }

    get numberOfElements(): number {
        return this.totalElements > this.size * (this.number + 1) ?
            this.size : this.totalElements - this.size * this.number;
    }

    constructor(num: number = 0, totalElements: number = 0, size: number = DEFAULT_PAGE_SIZE) {
        this.number = num;
        this.size = size;
        this.totalElements = totalElements;
    }

    toString(): string {
        return JSON.stringify({
            number: this.number,
            size: this.size,
            totalElements: this.totalElements,
            last: this.last,
            first: this.first,
            totalPages: this.totalPages,
            numberOfElements: this.numberOfElements
        });
    }
}

export class PaginationPageLabel {
    label: string;
    value: string;
}

/**
 * Interface Spring Pageable
 */
export class PaginationPagable<T> {
    first: boolean;
    last: boolean;
    number: number;
    numberOfElements: number;
    size: number;
    content: T[];
    sort: PaginationSort[];
    totalElements: number;
    totalPages: number;
}

export class PaginationSort {
    ascending: boolean;
    direction: string;
    ignoreCase: boolean;
    nullHandling: string;
    property: string;
}
